import request from '@host-panel/request';

import { AccessTokensResponse } from './generalSettinsTypes';

export async function fetchExportV4ApiKeyRequest() {
  return await request('/host-panel/publisher-api-key', { method: 'POST' });
}

export function getAccessTokensRequest(): Promise<AccessTokensResponse> {
  return request(`/host-panel/access-tokens`, {
    method: 'POST',
    data: {}
  });
}
